import store from '@/store'

const prefix = '/admin/reports/finance'

export default [
  {
    path: prefix + '/pay-to-vendors',
    name: 'pay-to-vendor',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/pay-to-vendor')
  },
  {
    path: prefix + '/income-statement-details',
    name: 'income-statement-details',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/income-statment-detail')
  },
  {
    path: prefix + '/gross-profit-product',
    name: 'gross-profit-product',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/gross-profit-product')
  },
  {
    path: prefix + '/gross-profit-customer',
    name: 'gross-profit-customer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/gross-profit-customer')
  },
  {
    path: prefix + '/sale-by-customer-summaries',
    name: 'sale-by-customer-summary',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/sale-by-customer-summary')
  },
  {
    path: prefix + '/account-receivables',
    name: 'account-receivable',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/account-receivable')
  },
  {
    path: prefix + '/cash-collections',
    name: 'cash-collection',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/cash-collection')
  },
  {
    path: prefix + '/yearly-sold-by-sale-types',
    name: 'yearly-sold-by-sale-type',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/yearly-sold-by-sale-type')
  },
  {
    path: prefix + '/customer_sales_by_months',
    name: 'customer_sales_by_month',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/customer_sales_by_month')
  },
  {
    path: prefix + '/sale-contracts',
    name: 'sale-contract-report',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/sale-contract')
  },
  {
    path: prefix + '/account-payables',
    name: 'account-payable',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/account-payable')
  },
  {
    path: prefix + '/cash-collection-restaurant-sales',
    name: 'cash-collection-restaurant-sales',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/finance/cash-collection-restaurant-sale')
  },
  {
    path: prefix + '/monthly-report-summarys',
    name: 'monthly-report-summarys',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance//monthly-report-summary')
  },
  {
    path: '/admin/reports/finance/transaction-back-dates',
    name: 'transaction-back-date',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/transetion-back-date')
  },
  {
    path: '/admin/reports/finance/purchase-sale-inventory',
    name: 'purchase-sale-inventory',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/purchase-sale-inventory')
  }
]
